import { useSelector } from 'react-redux';

import { selectIsLiveChat } from '../../common/selectors/chat';
import { selectFieldState } from '../../common/selectors/field';
import { isChatbotImageMultimodalityEnabled } from '../../util/isChatbotImageMultimodalityEnabled';

export const useIsAttachmentAvailable = () => {
  const { disabled, attachFile } = useSelector(selectFieldState);
  const isLiveChat = useSelector(selectIsLiveChat);

  const isDisabled = disabled && !isLiveChat;
  // The chatbotImageMultimodality experiment enables uploading images during the chatbot
  // conversation (before live chat), independent of an explicit attachFile node — but it must
  // still respect the disabled input UI, just like the attachFile path.
  return isLiveChat || ((attachFile || isChatbotImageMultimodalityEnabled()) && !isDisabled);
};
